import React from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import AccountSidebar from '../components/AccountSidebar/AccountSidebar'
import CuponsContainer from '../components/CuponsContainer/CuponsContainer'
import Footer from '../components/Footer/Footer'
import { Col, Container, Row } from 'react-bootstrap'

function Cupons() {
  return (
    <>
    <NavbarContainer/>
    <Container>
      <Row>
        <Col md={3}>
        <AccountSidebar/>

        </Col>
        <Col md={9}>
        <CuponsContainer/>

        </Col>
      </Row>
    </Container>
    <Footer/>
    </>
      )
}

export default Cupons